import axios from "axios";
import React, {use, useEffect, useState, replace} from "react";
import '../styles/global.css'; // Seu CSS global
import { useParams, useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { encryptPassword, decryptPassword, encryptString, decryptString } from "../utils/crypto";
import { v4 as uuidv4 } from 'uuid';
import { LocalConvenienceStoreOutlined } from "@mui/icons-material";

function Register() {
    const { IdTaxPayer } = 0;
    const guidTaxPayer = useParams().IdTaxPayer;
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const [taxpayer, setTaxPayer] = React.useState({
        IdTaxPayer: 0,
        txpFullName: '',
        txpDateOfBirth: '',
        txpFullAddress: '',
        txpCity: '',
        txpState: '',
        txpZipCode: '',
        txpCellPhone: '',
        txpOccupation: '',
        txpEmail: '',
        txpSSN: '',
        txpITIN: '',
        txpPassword: '',
        txpDL: '',
        txpSSC: '',
        txpSpouseFullName: '',
        txpSpouseDateOfBirth: '',
        txpSpouseCellPhone: '',
        txpSpouseOccupation: '',
        txpSpouseEmail: '',
        txpSpouseSSN: '',
        txpSpouseSSC: '',
        txpD1FullName: '',
        txpD1DateOfBirth: '',
        txpD1Relationship: '',
        txpD2FullName: '',
        txpD2DateOfBirth: '',
        txpD2Relationship: '',
        txpD3FullName: '',
        txpD3DateOfBirth: '',
        txpD3Relationship: '',
        txpD4FullName: '',
        txpD4DateOfBirth: '',
        txpD4Relationship: '',
        txpCreatedIn: new Date().toISOString(),
        txpCreatedBy: '',
        txpUpdatedIn: new Date().toISOString(),
        txpUpdatedBy: '',
        txpCodeGUID: uuidv4(),
        txpStatus: 1
    });

    const [taxpayerInfo, setTaxpayerInfo] = React.useState({
        IdTaxPayer: 0,
        txpFullName: '',
        txpDateOfBirth: '',
        txpFullAddress: '',
        txpCity: '',
        txpState: '',
        txpZipCode: '',
        txpCellPhone: '',
        txpOccupation: '',
        txpEmail: '',
        txpSSN: '',
        txpITIN: '',
        txpPassword: '',
        txpDL: '',
        txpSSC: '',
        txpSpouseFullName: '',
        txpSpouseDateOfBirth: '',
        txpSpouseCellPhone: '',
        txpSpouseOccupation: '',
        txpSpouseEmail: '',
        txpSpouseSSN: '',
        txpSpouseSSC: '',
        txpD1FullName: '',
        txpD1DateOfBirth: '',
        txpD1Relationship: '',
        txpD2FullName: '',
        txpD2DateOfBirth: '',
        txpD2Relationship: '',
        txpD3FullName: '',
        txpD3DateOfBirth: '',
        txpD3Relationship: '',
        txpD4FullName: '',
        txpD4DateOfBirth: '',
        txpD4Relationship: '',
        txpCreatedIn: '',
        txpCreatedBy: '',
        txpUpdatedIn: '',
        txpUpdatedBy: '',
        txpCodeGUID: '',
        txpStatus: 1
    });
    
    useEffect(() => {
        if(guidTaxPayer && guidTaxPayer !== '') {
            setIsLoading(true);
            const dataToSend = { txpCodeGUID: guidTaxPayer };
            axios.post(process.env.REACT_APP_API_URL + `/routes.php?method=getTaxPayerByCodeGUID`,
                dataToSend,
                { headers: {
                    'X-Access-Token' : tokenAPI,
                    'Content-Type': 'application/json; charset=UTF-8'
                }
                })
            .then(response => {
                if(response.data && parseInt(response.data.IdTaxPayer) > 0) {
                    //setTaxpayerInfo(response.data);
                    //setTaxPayer(response.data);
                    //console.log(response.data);
                    //populaTaxPayer()
                    taxpayer['IdTaxPayer'] = response.data.IdTaxPayer;
                    taxpayer['txpFullName'] = response.data.txpFullName ? decryptString(response.data.txpFullName) : '';
                    taxpayer['txpDateOfBirth'] = response.data.txpDateOfBirth ? decryptString(response.data.txpDateOfBirth) : '';
                    taxpayer['txpFullAddress'] = response.data.txpFullAddress ? decryptString(response.data.txpFullAddress) : '';
                    taxpayer['txpCity'] = response.data.txpCity ? decryptString(response.data.txpCity) : '';
                    taxpayer['txpState'] = response.data.txpState ? decryptString(response.data.txpState) : '';
                    taxpayer['txpZipCode'] = response.data.txpZipCode ? decryptString(response.data.txpZipCode) : '';
                    taxpayer['txpCellPhone'] = response.data.txpCellPhone ? decryptString(response.data.txpCellPhone) : '';
                    taxpayer['txpOccupation'] = response.data.txpOccupation ? decryptString(response.data.txpOccupation) : '';
                    taxpayer['txpEmail'] = response.data.txpEmail;
                    taxpayer['txpSSN'] = response.data.txpSSN ? decryptString(response.data.txpSSN) : '';
                    taxpayer['txpITIN'] = response.data.txpITIN ? decryptString(response.data.txpITIN) : '';
                    taxpayer['txpPassword'] = "";
                    taxpayer['txpDL'] = response.data.txpDL ? decryptString(response.data.txpDL) : '';
                    taxpayer['txpSSC'] = response.data.txpSSC ? decryptString(response.data.txpSSC) : '';
                    taxpayer['txpSpouseFullName'] = response.data.txpSpouseFullName ? decryptString(response.data.txpSpouseFullName) : '';
                    taxpayer['txpSpouseDateOfBirth'] = response.data.txpSpouseDateOfBirth ? decryptString(response.data.txpSpouseDateOfBirth) : '';
                    taxpayer['txpSpouseCellPhone'] = response.data.txpSpouseCellPhone ? decryptString(response.data.txpSpouseCellPhone) : '';
                    taxpayer['txpSpouseOccupation'] = response.data.txpSpouseOccupation ? decryptString(response.data.txpSpouseOccupation) : '';
                    taxpayer['txpSpouseEmail'] = response.data.txpSpouseEmail ? decryptString(response.data.txpSpouseEmail) : '';
                    taxpayer['txpSpouseSSN'] = response.data.txpSpouseSSN ? decryptString(response.data.txpSpouseSSN) : '';
                    taxpayer['txpSpouseSSC'] = response.data.txpSpouseSSC ? decryptString(response.data.txpSpouseSSC) : '';
                    taxpayer['txpD1FullName'] = response.data.txpD1FullName ? decryptString(response.data.txpD1FullName) : '';
                    taxpayer['txpD1DateOfBirth'] = response.data.txpD1DateOfBirth ? decryptString(response.data.txpD1DateOfBirth) : '';
                    taxpayer['txpD1Relationship'] = response.data.txpD1Relationship ? decryptString(response.data.txpD1Relationship) : '';
                    taxpayer['txpD2FullName'] = response.data.txpD2FullName ? decryptString(response.data.txpD2FullName) : '';
                    taxpayer['txpD2DateOfBirth'] = response.data.txpD2DateOfBirth ? decryptString(response.data.txpD2DateOfBirth) : '';
                    taxpayer['txpD2Relationship'] = response.data.txpD2Relationship ? decryptString(response.data.txpD2Relationship) : '';
                    taxpayer['txpD3FullName'] = response.data.txpD3FullName ? decryptString(response.data.txpD3FullName) : '';
                    taxpayer['txpD3DateOfBirth'] = response.data.txpD3DateOfBirth ? decryptString(response.data.txpD3DateOfBirth) : '';
                    taxpayer['txpD3Relationship'] = response.data.txpD3Relationship ? decryptString(response.data.txpD3Relationship) : '';
                    taxpayer['txpD4FullName'] = response.data.txpD4FullName ? decryptString(response.data.txpD4FullName) : '';
                    taxpayer['txpD4DateOfBirth'] = response.data.txpD4DateOfBirth ? decryptString(response.data.txpD4DateOfBirth) : '';
                    taxpayer['txpD4Relationship'] = response.data.txpD4Relationship ? decryptString(response.data.txpD4Relationship) : '';
                    taxpayer['txpCreatedIn'] = response.data.txpCreatedIn;
                    taxpayer['txpCreatedBy'] = response.data.txpCreatedBy;
                    taxpayer['txpUpdatedIn'] = response.data.txpUpdatedIn;
                    taxpayer['txpUpdatedBy'] = response.data.txpUpdatedBy;
                    taxpayer['txpCodeGUID'] = response.data.txpCodeGUID;
                    setIsLoading(false);
                }
            })
            .catch(error => {
                setIsLoading(false);
                if(error && error.Message) {
                    alert(error.Message);
                } else {
                    alert('An error occurred while fetching the tax payer.');
                }
            });
        }
    }, [IdTaxPayer]);

    //function populaTaxPayer() {
//     if(taxpayer.IdTaxPayer === 0 && taxpayerInfo.IdTaxPayer > 0) {
//         setTaxPayer['IdTaxPayer'] = taxpayerInfo.IdTaxPayer;
//         setTaxPayer['txpFullName'] = decryptPassword(taxpayerInfo.txpFullName);
//         setTaxPayer['txpDateOfBirth'] = decryptPassword(taxpayerInfo.txpDateOfBirth);
//         setTaxPayer['txpFullAddress'] = decryptPassword(taxpayerInfo.txpFullAddress);
//         setTaxPayer['txpCity'] = decryptPassword(taxpayerInfo.txpCity);
//         setTaxPayer['txpState'] = decryptPassword(taxpayerInfo.txpState);
//         setTaxPayer['txpZipCode'] = decryptPassword(taxpayerInfo.txpZipCode);
//         setTaxPayer['txpCellPhone'] = taxpayerInfo.txpCellPhone;
//         setTaxPayer['txpOccupation'] = taxpayerInfo.txpOccupation;
//         setTaxPayer['txpEmail'] = taxpayerInfo.txpEmail;
//         setTaxPayer['txpSSN'] = taxpayerInfo.txpSSN;
//         setTaxPayer['txpITIN'] = taxpayerInfo.txpITIN;
//         setTaxPayer['txpPassword'] = "";
//         setTaxPayer['txpDL'] = taxpayerInfo.txpDL;
//         setTaxPayer['txpSSC'] = taxpayerInfo.txpSSC;
//         setTaxPayer['txpSpouseFullName'] = taxpayerInfo.txpSpouseFullName;
//         setTaxPayer['txpSpouseDateOfBirth'] = taxpayerInfo.txpSpouseDateOfBirth;
//         setTaxPayer['txpSpouseCellPhone'] = taxpayerInfo.txpSpouseCellPhone;
//         setTaxPayer['txpSpouseOccupation'] = taxpayerInfo.txpSpouseOccupation;
//         setTaxPayer['txpSpouseEmail'] = taxpayerInfo.txpSpouseEmail;
//         setTaxPayer['txpSpouseSSN'] = taxpayerInfo.txpSpouseSSN;
//         setTaxPayer['txpSpouseSSC'] = taxpayerInfo.txpSpouseSSC;
//         setTaxPayer['txpD1FullName'] = taxpayerInfo.txpD1FullName;
//         setTaxPayer['txpD1DateOfBirth'] = taxpayerInfo.txpD1DateOfBirth;
//         setTaxPayer['txpD1Relationship'] = taxpayerInfo.txpD1Relationship;
//         setTaxPayer['txpD2FullName'] = taxpayerInfo.txpD2FullName;
//         setTaxPayer['txpD2DateOfBirth'] = taxpayerInfo.txpD2DateOfBirth;
//         setTaxPayer['txpD2Relationship'] = taxpayerInfo.txpD2Relationship;
//         setTaxPayer['txpD3FullName'] = taxpayerInfo.txpD3FullName;
//         setTaxPayer['txpD3DateOfBirth'] = taxpayerInfo.txpD3DateOfBirth;
//         setTaxPayer['txpD3Relationship'] = taxpayerInfo.txpD3Relationship;   
//         setTaxPayer['txpD4FullName'] = taxpayerInfo.txpD4FullName;
//         setTaxPayer['txpD4DateOfBirth'] = taxpayerInfo.txpD4DateOfBirth;
//         setTaxPayer['txpD4Relationship'] = taxpayerInfo.txpD4Relationship;
// } 

    
    function handleInputChange(e) {
        const { name, value } = e.target;
        setTaxPayer({ ...taxpayer, [name]: value });

        //se o campo for txpEmail, txpCellPhone, txpSSN, txpSSC ou txpDL, usar o axios e consultar o método validateAccess para verificar se o login já existe e exibir uma mensagem de alerta caso exista
        if(name === 'txpEmail' || name === 'txpCellPhone' || name === 'txpSSN' || name === 'txpSSC' || name === 'txpDL') {
            const dataToSend = { login: value, idtaxpayer: taxpayer.IdTaxPayer };
            //console.log(dataToSend);
            axios.post(process.env.REACT_APP_API_URL + `/routes.php?method=validateTaxPayer`,
                dataToSend,
                { headers: {
                    'X-Access-Token' : tokenAPI,
                    'Content-Type': 'application/json; charset=UTF-8'
                }
                })
            .then(response => {
                if(response.data.Message) {
                    // console.log(response.data);
                    if(response.data.Message !== "Invalid login credentials") {
                        alert(response.data.Message);
                    }
                } else {
                    if(name === 'txpEmail'){
                        alert('This email address is already registered. Please use a different email address or sign in to your account.');
                        setTaxPayer({ ...taxpayer, txpEmail: '' });
                    } else if (name === 'txpCellPhone') {
                        alert('This cell phone number is already registered. Please use a different cell phone number or sign in to your account.');
                        setTaxPayer({ ...taxpayer, txpCellPhone: '' });
                    } else if (name === 'txpSSN') {
                        alert('This SSN is already registered. Please use a different SSN or sign in to your account.');
                        setTaxPayer({ ...taxpayer, txpSSN: '' });
                    } else if (name === 'txpSSC') {
                        alert('This SSC is already registered. Please use a different SSC or sign in to your account.');
                        setTaxPayer({ ...taxpayer, txpSSC: '' });
                    } else if (name === 'txpDL') {
                        alert('This DL is already registered. Please use a different DL or sign in to your account.');
                        setTaxPayer({ ...taxpayer, txpDL: '' });
                    }
                }
            })
            .catch(error => {
                if(error && error.Message) {
                    alert(error.Message + '2');
                } else {
                    alert('An error occurred while validating the access.' + error);
                }
            });
        
        }

    }

    console.log(taxpayer);
    
    var bloqueio = false;
    function handleFormSubmit(e) {
        e.preventDefault();
        setIsLoading(true);
        if (!bloqueio) {
            bloqueio = true;

            taxpayer.txpEmail = taxpayer.txpEmail.toLowerCase()
                .replace(/[áàãâä]/g, 'a')
                .replace(/[éèêë]/g, 'e')
                .replace(/[íìîï]/g, 'i')
                .replace(/[óòõôö]/g, 'o')
                .replace(/[úùûü]/g, 'u')
                .replace(/[ç]/g, 'c');
            taxpayer.txpSpouseEmail = taxpayer.txpSpouseEmail.toLowerCase()
                .replace(/[áàãâä]/g, 'a')
                .replace(/[éèêë]/g, 'e')
                .replace(/[íìîï]/g, 'i')
                .replace(/[óòõôö]/g, 'o')
                .replace(/[úùûü]/g, 'u')
                .replace(/[ç]/g, 'c');
            taxpayer.txpUpdatedIn = new Date().toISOString();

            if(taxpayer.txpPassword && taxpayer.txpPassword.length > 0) {
                taxpayer.txpPassword = encryptPassword(taxpayer.txpPassword);
            }

            taxpayer.txpSSC = taxpayer.txpSSN;

            taxpayer.txpCreatedBy = taxpayer.txpCreatedBy ? taxpayer.txpCreatedBy : taxpayer.txpFullName;
            //taxpayer.txpCreatedIn = new Date().toISOString();

            taxpayer.txpUpdatedBy = taxpayer.txpUpdatedBy ? taxpayer.txpUpdatedBy : taxpayer.txpFullName;
            taxpayer.txpUpdatedIn = new Date().toISOString();


            // console.log('Email informado: '+ taxpayer.txpEmail);
            // console.log('Email criptografado: '+ encryptEmail(taxpayer.txpEmail));
            // console.log('Email descriptografado: '+ decryptEmail(encryptEmail(taxpayer.txpEmail)));
            // return;
            //criptografar todos os campos de cadastro
            taxpayer.txpFullName = taxpayer.txpFullName ? encryptString(taxpayer.txpFullName) : taxpayer.txpFullName;
            taxpayer.txpDateOfBirth = taxpayer.txpDateOfBirth ? encryptString(taxpayer.txpDateOfBirth) : taxpayer.txpDateOfBirth;
            taxpayer.txpFullAddress = taxpayer.txpFullAddress ? encryptString(taxpayer.txpFullAddress) : taxpayer.txpFullAddress;
            taxpayer.txpCity = taxpayer.txpCity ? encryptString(taxpayer.txpCity) : taxpayer.txpCity;
            taxpayer.txpState = taxpayer.txpState ? encryptString(taxpayer.txpState) : taxpayer.txpState;
            taxpayer.txpZipCode = taxpayer.txpZipCode ? encryptString(taxpayer.txpZipCode) : taxpayer.txpZipCode;
            taxpayer.txpCellPhone = taxpayer.txpCellPhone ? encryptString(taxpayer.txpCellPhone) : taxpayer.txpCellPhone;
            taxpayer.txpOccupation = taxpayer.txpOccupation ? encryptString(taxpayer.txpOccupation) : taxpayer.txpOccupation;
            //taxpayer.txpEmail = taxpayer.txpEmail ? encryptString(taxpayer.txpEmail) : taxpayer.txpEmail;
            taxpayer.txpSSN = taxpayer.txpSSN ? encryptString(taxpayer.txpSSN) : taxpayer.txpSSN;
            taxpayer.txpITIN = taxpayer.txpITIN ? encryptString(taxpayer.txpITIN) : taxpayer.txpITIN;
            taxpayer.txpDL = taxpayer.txpDL ? encryptString(taxpayer.txpDL) : taxpayer.txpDL;
            taxpayer.txpSSC = taxpayer.txpSSC ? encryptString(taxpayer.txpSSC) : taxpayer.txpSSC;
            taxpayer.txpSpouseFullName = taxpayer.txpSpouseFullName ? encryptString(taxpayer.txpSpouseFullName) : taxpayer.txpSpouseFullName;
            taxpayer.txpSpouseDateOfBirth = taxpayer.txpSpouseDateOfBirth ? encryptString(taxpayer.txpSpouseDateOfBirth) : taxpayer.txpSpouseDateOfBirth;
            taxpayer.txpSpouseCellPhone = taxpayer.txpSpouseCellPhone ? encryptString(taxpayer.txpSpouseCellPhone) : taxpayer.txpSpouseCellPhone;
            taxpayer.txpSpouseOccupation = taxpayer.txpSpouseOccupation ? encryptString(taxpayer.txpSpouseOccupation) : taxpayer.txpSpouseOccupation;
            taxpayer.txpSpouseEmail = taxpayer.txpSpouseEmail ? encryptString(taxpayer.txpSpouseEmail) : taxpayer.txpSpouseEmail;
            taxpayer.txpSpouseSSN = taxpayer.txpSpouseSSN ? encryptString(taxpayer.txpSpouseSSN) : taxpayer.txpSpouseSSN;
            taxpayer.txpSpouseSSC = taxpayer.txpSpouseSSC ? encryptString(taxpayer.txpSpouseSSC) : taxpayer.txpSpouseSSC;
            taxpayer.txpD1FullName = taxpayer.txpD1FullName ? encryptString(taxpayer.txpD1FullName) : taxpayer.txpD1FullName;
            taxpayer.txpD1DateOfBirth = taxpayer.txpD1DateOfBirth ? encryptString(taxpayer.txpD1DateOfBirth) : taxpayer.txpD1DateOfBirth;
            taxpayer.txpD1Relationship = taxpayer.txpD1Relationship ? encryptString(taxpayer.txpD1Relationship) : taxpayer.txpD1Relationship;
            taxpayer.txpD2FullName = taxpayer.txpD2FullName ? encryptString(taxpayer.txpD2FullName) : taxpayer.txpD2FullName;
            taxpayer.txpD2DateOfBirth = taxpayer.txpD2DateOfBirth ? encryptString(taxpayer.txpD2DateOfBirth) : taxpayer.txpD2DateOfBirth;
            taxpayer.txpD2Relationship = taxpayer.txpD2Relationship ? encryptString(taxpayer.txpD2Relationship) : taxpayer.txpD2Relationship;
            taxpayer.txpD3FullName = taxpayer.txpD3FullName ? encryptString(taxpayer.txpD3FullName) : taxpayer.txpD3FullName;
            taxpayer.txpD3DateOfBirth = taxpayer.txpD3DateOfBirth ? encryptString(taxpayer.txpD3DateOfBirth) : taxpayer.txpD3DateOfBirth;
            taxpayer.txpD3Relationship = taxpayer.txpD3Relationship ? encryptString(taxpayer.txpD3Relationship) : taxpayer.txpD3Relationship;
            taxpayer.txpD4FullName = taxpayer.txpD4FullName ? encryptString(taxpayer.txpD4FullName) : taxpayer.txpD4FullName;
            taxpayer.txpD4DateOfBirth = taxpayer.txpD4DateOfBirth ? encryptString(taxpayer.txpD4DateOfBirth) : taxpayer.txpD4DateOfBirth;
            taxpayer.txpD4Relationship = taxpayer.txpD4Relationship ? encryptString(taxpayer.txpD4Relationship) : taxpayer.txpD4Relationship;
        
            //console.log(taxpayer); return;

            const dataToSend = { ...taxpayer };
            //console.log(dataToSend); return;

            if(taxpayer.IdTaxPayer > 0) {
                axios.post(process.env.REACT_APP_API_URL + `/routes.php?method=updateTaxPayer`,
                    dataToSend,
                    { headers: {
                        'X-Access-Token' : tokenAPI,
                        'Content-Type': 'application/json; charset=UTF-8'
                    }
                    })
                .then(response => {
                    if(response.data.Message && response.data.Message === 'Tax payer updated successfully') {
                        console.log("aqui-1");
                        alert(response.data.Message);
                        navigate('/TaxPayer/'+ taxpayer.IdTaxPayer);
                        setIsLoading(false);
                    } else {
                        console.log("aqui-2");
                        //alert(response.data.Message);
                        setIsLoading(false);
                        bloqueio = false;
                        navigate('/TaxPayer/'+ taxpayer.IdTaxPayer);
                    }
                })
                .catch(error => {
                    if(error.response && error.response.data && error.response.data.Message) {
                        alert(error.response.data.Message);
                        bloqueio = false;
                        setIsLoading(false);
                    } else {
                        alert('An error occurred while updating the tax payer.');
                        bloqueio = false;

                        setIsLoading(false);
                    }

                });
            } else {
                axios.post(process.env.REACT_APP_API_URL + `/routes.php?method=createTaxPayer`,
                    dataToSend,
                    { headers: {
                        'X-Access-Token' : tokenAPI,
                        'Content-Type': 'application/json; charset=UTF-8'
                    }
                    })
                .then(response => {
                    //console.log(response.data);
                    if(response.data.Message) {
                        console.log("aqui-3");
                        alert(response.data.Message);
                        console.log(response.data.Message);
                            bloqueio = false;
                        setIsLoading(false);
                    } else {
                        console.log("aqui-4");
                        alert('Tax payer created successfully!');
                        setIsLoading(false);

                        const dataToSend = { login: taxpayer.txpEmail, password: taxpayer.txpPassword };
                        axios.post(process.env.REACT_APP_API_URL + `/routes.php?method=validateTaxPayer`, 
                        dataToSend,
                            { headers: { 
                                'X-Access-Token' : tokenAPI,
                                'Content-Type': 'application/json; charset=UTF-8' 
                                }
                            })
                        .then(response => {
                            console.log("aqui-5");
                            if(response.data && response.data.Message && response.data.Message !== 'Access granted') {
                                alert(response.data.Message);
                                setIsLoading(false);
                                bloqueio = false;
                            } else {
                                console.log("aqui-6");
                                setIsLoading(false);
                                bloqueio = false;
                                navigate('/Register/' + response.data.IdTaxPayer);
                            }
                        })
                        .catch(error => {
                            alert('Error validating access: ' + JSON.stringify(error.message));
                            bloqueio = false;
                            setIsLoading(false);
                        });
                    }
                })
                .catch(error => {
                    if(error.response && error.response.data && error.response.data.Message) {
                        alert(error.response.data.Message);
                        bloqueio = false;
                        setIsLoading(false);
                    } else {
                        alert('An error occurred while creating the tax payer.');
                        bloqueio = false;
                        setIsLoading(false);
                    }
                });
            }
        }
    }

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div className='headerMain'>
                    <div>
                        <label>Register</label>
                    </div>
                </div>
                <div className="pr8 pl8 mt2 text-align-center">
                    <label className='labelTitulo' >Please fill out the form below to register for our tax services.</label>
                </div>
                {isLoading ? (
                    <div className="text-align-center mt4">
                        <CircularProgress />
                        <p>please wait, decrypting your registration...</p>
                    </div>
                ) : (
                    <>
                        {/* um formulário de cadastro para obter informações pessoais do contribuinte, cônjuge e dependentes */}
                        <div className='pr8 pl8 text-align-left'>
                            <div>
                                <form className='mt4' onSubmit={handleFormSubmit}>
                                    {/* group TAXPAYER */}
                            <div className="w100">
                                <div className='text-align-left divForm fs16 mb2'>
                                    <label>TAXPAYER</label>
                                </div>
                                {/* txpFullName */}
                                <div className='text-align-left divForm fs16'>
                                    <label className='labelTitulo'>Full Name</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpFullName" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off"   placeholder='Full Name' required value={taxpayer.txpFullName} onChange={handleInputChange} />
                                </div>
                                {/* txpDateOfBirth */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Date of Birth (mm/dd/yyyy)</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpDateOfBirth" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Date of Birth (mm/dd/yyyy)' required value={taxpayer.txpDateOfBirth} onChange={handleInputChange} />
                                </div>
                                {/* txpFullAddress */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Full Address</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpFullAddress" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Full Address' required value={taxpayer.txpFullAddress} onChange={handleInputChange} />
                                </div>
                                {/* txpCity */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>City</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpCity" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='City' required value={taxpayer.txpCity} onChange={handleInputChange} />
                                </div>
                                {/* txpState */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>State</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpState" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='State' required value={taxpayer.txpState} onChange={handleInputChange} />
                                </div>
                                {/* txpZipCode */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Zip Code</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpZipCode" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Zip Code' required value={taxpayer.txpZipCode} onChange={handleInputChange} />
                                </div>
                                {/* txpCellPhone */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Cell Phone</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpCellPhone" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Cell Phone' required value={taxpayer.txpCellPhone} onChange={handleInputChange} />
                                </div>
                                {/* txpOccupation */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Occupation</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpOccupation" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Occupation' required value={taxpayer.txpOccupation} onChange={handleInputChange} />
                                </div>
                                {/* txpEmail */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Email</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="email" name="txpEmail" className="p1 fs12 w100 text-align-left borderRadius LowerCase" autoComplete="off" placeholder='Email' required value={taxpayer.txpEmail} onChange={handleInputChange} />
                                </div>
                                {/* txpSSN */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>SSN - State Social Security Number (SSC)</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpSSN" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='SSN' required value={taxpayer.txpSSN} onChange={handleInputChange} />
                                </div>
                                {/* txpDL */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Driver's License</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpDL" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder="Driver's License" required value={taxpayer.txpDL} onChange={handleInputChange} />
                                </div>
                                {/* txpSSC */}
                                <div className='text-align-left divForm fs16 mt1 d-none'>
                                    <label className='labelTitulo'>SSN - State Social Security Number (SSC)</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12 d-none'>
                                    <input type="text" name="txpSSC" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='State Social Security Number' value={taxpayer.txpSSC} onChange={handleInputChange} />
                                </div>
                                {/* txpITIN */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>ITIN - Individual Taxpayer Identification Number</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpITIN" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='ITIN' value={taxpayer.txpITIN} onChange={handleInputChange} />
                                </div>                                
                            </div>
                            {/* group spouse */}
                            <div className="w100 mt4">
                                <div className='text-align-left divForm fs16 mb2'>
                                    <label>SPOUSE</label>
                                </div>
                                {/* txpSpouseFullName */}
                                <div className='text-align-left divForm fs16'>
                                    <label className='labelTitulo'>Full Name</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpSpouseFullName" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Full Name' value={taxpayer.txpSpouseFullName} onChange={handleInputChange} />
                                </div>
                                {/* txpSpouseDateOfBirth */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Date of Birth (mm/dd/yyyy)</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpSpouseDateOfBirth" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Date of Birth (mm/dd/yyyy)' value={taxpayer.txpSpouseDateOfBirth} onChange={handleInputChange} />
                                </div>
                                {/* txpSpouseCellPhone */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Cell Phone</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpSpouseCellPhone" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Cell Phone' value={taxpayer.txpSpouseCellPhone} onChange={handleInputChange} />
                                </div>
                                {/* txpSpouseOccupation */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Occupation</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpSpouseOccupation" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Occupation' value={taxpayer.txpSpouseOccupation} onChange={handleInputChange} />
                                </div>
                                {/* txpSpouseEmail */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Email</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="email" name="txpSpouseEmail" className="p1 fs12 w100 text-align-left borderRadius LowerCase" autoComplete="off" placeholder='Email' value={taxpayer.txpSpouseEmail} onChange={handleInputChange} />
                                </div>
                                {/* txpSpouseSSN */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>SSN - State Social Security Number (SSC)</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpSpouseSSN" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='SSN' value={taxpayer.txpSpouseSSN} onChange={handleInputChange} />
                                </div>
                            </div>
                            {/* group dependents */}
                            <div className="w100 mt4">
                                <div className='text-align-left divForm fs16 mb2'>
                                    <label>DEPENDENTS</label>
                                </div>
                                    {/* D1 */}
                                <div className='text-align-left divForm fs12 mt1'>
                                    <label>1st dependent:</label>
                                </div>
                                    {/* txpD1FullName */}
                                <div className='text-align-left divForm fs16'>
                                    <label className='labelTitulo'>Full Name</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpD1FullName" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Full Name' value={taxpayer.txpD1FullName} onChange={handleInputChange} />
                                </div>
                                    {/* txpD1DateOfBirth */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Date of Birth (mm/dd/yyyy)</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpD1DateOfBirth" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Date of Birth (mm/dd/yyyy)' value={taxpayer.txpD1DateOfBirth} onChange={handleInputChange} />
                                </div>
                                    {/* txpD1Relationship */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Relationship with Taxpayer</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpD1Relationship" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Relationship with Taxpayer' value={taxpayer.txpD1Relationship} onChange={handleInputChange} />
                                </div>
                                    {/* D2 */}
                                <div className='text-align-left divForm fs12 mt1'>
                                    <label>2nd dependent:</label>
                                </div>
                                    {/* txpD2FullName */}
                                <div className='text-align-left divForm fs16'>
                                    <label className='labelTitulo'>Full Name</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpD2FullName" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Full Name' value={taxpayer.txpD2FullName} onChange={handleInputChange} />
                                </div>
                                    {/* txpD2DateOfBirth */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Date of Birth (mm/dd/yyyy)</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpD2DateOfBirth" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Date of Birth (mm/dd/yyyy)' value={taxpayer.txpD2DateOfBirth} onChange={handleInputChange} />
                                </div>
                                    {/* txpD2Relationship */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Relationship with Taxpayer</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpD2Relationship" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Relationship with Taxpayer' value={taxpayer.txpD2Relationship} onChange={handleInputChange} />
                                </div>
                                    {/* D3 */}
                                <div className='text-align-left divForm fs12 mt1'>
                                    <label>3rd dependent:</label>
                                </div>
                                    {/* txpD3FullName */}
                                <div className='text-align-left divForm fs16'>
                                    <label className='labelTitulo'>Full Name</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpD3FullName" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Full Name' value={taxpayer.txpD3FullName} onChange={handleInputChange} />
                                </div>
                                    {/* txpD3DateOfBirth */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Date of Birth (mm/dd/yyyy)</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpD3DateOfBirth" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Date of Birth (mm/dd/yyyy)' value={taxpayer.txpD3DateOfBirth} onChange={handleInputChange} />
                                </div>
                                    {/* txpD3Relationship */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Relationship with Taxpayer</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpD3Relationship" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Relationship with Taxpayer' value={taxpayer.txpD3Relationship} onChange={handleInputChange} />
                                </div>
                                    {/* D4 */}
                                <div className='text-align-left divForm fs12 mt1'>
                                    <label>4th dependent:</label>
                                </div>
                                    {/* txpD4FullName */}
                                <div className='text-align-left divForm fs16'>
                                    <label className='labelTitulo'>Full Name</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpD4FullName" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Full Name' value={taxpayer.txpD4FullName} onChange={handleInputChange} />
                                </div>
                                    {/* txpD4DateOfBirth */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Date of Birth (mm/dd/yyyy)</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpD4DateOfBirth" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Date of Birth (mm/dd/yyyy)' value={taxpayer.txpD4DateOfBirth} onChange={handleInputChange} />
                                </div>
                                    {/* txpD4Relationship */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Relationship with Taxpayer</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="txpD4Relationship" className="p1 fs12 w100 text-align-left borderRadius UpperCase" autoComplete="off" placeholder='Relationship with Taxpayer' value={taxpayer.txpD4Relationship} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div>
                                {/* txpPassword */}
                                <div className='text-align-left divForm fs16 mt1'>
                                    <label className='labelTitulo'>Password (required for access, and update your information)</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="password" name="txpPassword" className="p1 fs12 w100 text-align-left borderRadius" autoComplete="off" required defaultValue='' value={taxpayer.txpPassword} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="text-align-right">
                                {isLoading ? (
                                <div className='d-flex w100 justify-content-center mt2 mb4'>
                                    <CircularProgress />
                                </div>
                                ) : (
                                    <button type="submit" className=' mt2 mb4 p1 borderRadius fs12' style={{ textDecoration: 'none', cursor: 'pointer' }}>{taxpayer.IdTaxPayer > 0 ? 'UPDATE' : 'REGISTER'}</button>
                                )}
                            </div>
                        </form>
                    </div>
                        </div>
                    </>
                )}

            </main>
        </div>
    );
}

export default Register;